export const supportedMacros = [
  'ADCATEGORIES',
  'ADCOUNT',
  'ADPLAYHEAD',
  'ADSERVINGID',
  'ADTYPE',
  'APIFRAMEWORKS',
  'APPBUNDLE',
  'ASSETURI',
  'BLOCKEDADCATEGORIES',
  'BREAKMAXADLENGTH',
  'BREAKMAXADS',
  'BREAKMAXDURATION',
  'BREAKMINADLENGTH',
  'BREAKMINDURATION',
  'BREAKPOSITION',
  'CLICKPOS',
  'CLICKTYPE',
  'CLIENTUA',
  'CONTENTID',
  'CONTENTPLAYHEAD', // @deprecated VAST 4.1
  'CONTENTURI',
  'DEVICEIP',
  'DEVICEUA',
  'DOMAIN',
  'EXTENSIONS',
  'GDPRCONSENT',
  'IFA',
  'IFATYPE',
  'INVENTORYSTATE',
  'LATLONG',
  'LIMITADTRACKING',
  'MEDIAMIME',
  'MEDIAPLAYHEAD',
  'OMIDPARTNER',
  'PAGEURL',
  'PLACEMENTTYPE',
  'PLAYERCAPABILITIES',
  'PLAYERSIZE',
  'PLAYERSTATE',
  'PODSEQUENCE',
  'REGULATIONS',
  'SERVERSIDE',
  'SERVERUA',
  'TRANSACTIONID',
  'UNIVERSALADID',
  'VASTVERSIONS',
  'VERIFICATIONVENDORS',
];
